export const ITEM_NAME_MAX_LENGTH = 200;
export const DEFAULT_PRICE = '0.00';
export const getItemModifierGroups = (item, createdModifierGroups) => {
  if (createdModifierGroups) {
    return createdModifierGroups;
  }
  return item.modifierGroups;
};
export const getPriceVariants = (item, createdPriceVariants) => {
  var _item$priceVariants;
  if (createdPriceVariants) {
    return createdPriceVariants;
  }
  return (_item$priceVariants = item.priceVariants) == null ? void 0 : _item$priceVariants.variants;
};
export const attachCreatedEntitiesToItem = _ref => {
  let {
    item,
    createdModifierGroups,
    createdPriceVariants
  } = _ref;
  const itemModifierGroups = getItemModifierGroups(item, createdModifierGroups);
  const itemPriceVariants = getPriceVariants(item, createdPriceVariants);
  return {
    ...item,
    ...(itemModifierGroups && {
      modifierGroups: itemModifierGroups
    }),
    ...(itemPriceVariants && {
      priceVariants: {
        variants: itemPriceVariants
      }
    })
  };
};
export const getDuplicateItemName = (duplicatedNameCreator, name) => duplicatedNameCreator(name).substring(0, ITEM_NAME_MAX_LENGTH);
//# sourceMappingURL=item.js.map